import { useEffect, useState } from "react";

// Tailwind v4 breakpoints - defined inline since config is now CSS-first
const tailwindScreens = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px",
  "2xl": "1536px",
  "3xl": "2000px",
} as const;

const screens = Object.entries(tailwindScreens).reduce(
  (acc, [key, value]) => {
    acc[parseInt(value.replace("px", ""), 10)] = key;
    return acc;
  },
  {} as Record<number, string>,
);

const breakpoints = Object.keys(screens)
  .map(Number)
  .sort((a, b) => b - a);

export const useScreen = () => {
  const [size, setSize] = useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });
  const breakpoint =
    breakpoints.find((screen) => size.width && size.width > screen) || 0;
  const currentScreen = screens[breakpoint];
  const isWide =
    currentScreen === "xl" ||
    currentScreen === "2xl" ||
    currentScreen === "3xl";

  useEffect(() => {
    const handleResize = () => {
      setSize({ width: window.innerWidth, height: window.innerHeight });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return {
    ...size,
    isWide,
    breakpoint: currentScreen,
    screens: tailwindScreens,
  };
};
